export enum SkillLevelStatusEnum {
    UNASSIGNED = "unassigned",
    ASSIGNED = "assigned",
    ACQUIRED = "acquired",
}

export type ISkillLevelStatus = `${SkillLevelStatusEnum}`;
